import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ViewDetails from './ViewDetails';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { zhanden } from '@src/utils/zhanden'; 

const FormInfo = ({ understand, understandHandle, languages }) => {
    const [confirmData, setConfirmData] = useState({
        isClickOk: understand,
        isCheck: false,
        isClosePopup: true,
    });
    const confirmDataHandle = (value) => {
        document.body.style.overflow = '';
        setConfirmData(value);

        understandHandle(value.isClickOk);
    };
    const viewDetailHandle = () => {
        document.body.style.overflow = '';
        setConfirmData({
            isClickOk: understand,
            isCheck: false,
            isClosePopup: false,
        });
    };

    return (
        <div className={styles.formInfo}>
            <div
                className={styles.formInfoBox}>
                <div
                    className={`${styles.formInfoIcon} ${understand ? styles.active : ''}`}
                    onClick={() => {
                        understandHandle(!understand);
                    }}
                />
                <div className={styles.formInfoText}>
                    {zhanden[languages].declaration.title}
                    <span
                        onClick={() => {
                            viewDetailHandle(confirmData);
                        }}
                        className={styles.formDetail}>
                            {zhanden[languages].declaration.moreText}
                    </span>
                </div>
            </div>
            <ViewDetails languages={languages} confirmData={confirmData} confirmDataHandle={confirmDataHandle} />
        </div>
    );
};

FormInfo.propTypes = {
    understand: PropTypes.bool,
    understandHandle: PropTypes.func,
    languages: PropTypes.string
};

export default errorBoundary(FormInfo);
